import useFacilityData from "../hooks/useFacilityData.ts"
import { useStaticQuery, graphql } from "gatsby"

export default () => {
  const data = useFacilityData()

  const facilityData = data.sanityFacility

  const facilityInfo = facilityData.facilityObj.facilityInfo

  const articleData = useStaticQuery(graphql`
    query ArticlesForNavQuery {
      allSanityArticle(sort: { fields: articleObj___date, order: DESC }) {
        edges {
          node {
            articleObj {
              _key
              allFacilities
              facilities {
                facilityObj {
                  facilityName
                }
              }
            }
          }
        }
      }
    }
  `)

  const articleArr = articleData.allSanityArticle.edges

  const hasArticlesForCurrFacility = articleArr.filter(article => {
    const articleObj = article.node.articleObj

    const hasCurrFacility =
      articleObj.facilities.filter(
        facility =>
          facility.facilityObj.facilityName === facilityData.facilityName
      ).length > 0

    return hasCurrFacility || articleObj.allFacilities
  })

  return articleArr.length > 0 && hasArticlesForCurrFacility
}
